import { render } from "./SignPadList.vue?vue&type=template&id=686ef7b2"
import script from "./SignPadList.vue?vue&type=script&lang=js"
export * from "./SignPadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__